import { Skeleton, Stack } from '@mui/material';
import Typography from '../../../../../../../../components/Typography';
import ClassListSkeleton from './ClassList/skeleton';

const AttendanceDataSkeleton = () => {
  return (
    <Stack gap={2}>
      <Typography variant="paragraphBold" component="h3">
        <Skeleton variant="text" width={250} />
      </Typography>
      <Typography variant="paragraphRegular">
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="50%" />
      </Typography>
      <Stack gap={2}>
        <Typography
          variant="paragraphBold"
          px={2}
          pb={1}
          position="sticky"
          top={0}
          zIndex={1}
          bgcolor="white"
        >
          <Skeleton variant="text" width={250} />
        </Typography>
        <ClassListSkeleton />
      </Stack>
    </Stack>
  );
};

export default AttendanceDataSkeleton;
